import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function SubscriptionSuccess() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [status, setStatus] = useState("polling");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled || attempts.current >= 10) return;
      attempts.current += 1;
      try {
        const { data } = await api.get(`/subscriptions/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-32 text-center" data-testid="subscription-success-page">
      {status === "polling" && (
        <>
          <Loader2 className="w-10 h-10 animate-spin text-olive mx-auto" />
          <h1 className="font-serif text-4xl mt-6">Activating your subscription…</h1>
        </>
      )}
      {status === "paid" && (
        <div data-testid="subscription-paid">
          <CheckCircle2 className="w-14 h-14 text-olive mx-auto" />
          <h1 className="font-serif text-5xl mt-6 tracking-tight">Welcome aboard.</h1>
          <p className="text-ink-soft mt-4 max-w-md mx-auto">Your subscription is active. Your first bottle will ship within the next cycle.</p>
          <Link to="/subscriptions" className="inline-block mt-10 bg-olive text-bone px-8 py-4 rounded-sm text-sm" data-testid="view-subs">Manage subscriptions</Link>
        </div>
      )}
      {(status === "expired" || status === "error") && (
        <div data-testid="subscription-error">
          <XCircle className="w-14 h-14 text-terracotta mx-auto" />
          <h1 className="font-serif text-4xl mt-6">We couldn't activate it.</h1>
          <Link to="/shop" className="inline-block mt-8 bg-olive text-bone px-8 py-4 rounded-sm text-sm">Back to shop</Link>
        </div>
      )}
    </div>
  );
}
